import { FormActionFrameworkStep, registerStep } from '../step';
import { resolveTemplate } from '../template';
export class LogStep extends FormActionFrameworkStep {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'log'
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                message: '',
            }
        });
    }
    async execute(context) {
        const raw = (typeof this.config.message === 'string' && this.config.message) || '';
        const resolved = resolveTemplate(raw, context);
        const text = resolved == null
            ? ''
            : typeof resolved === 'object'
                ? JSON.stringify(resolved)
                : String(resolved);
        console.log(`[FAF log] ${text}`);
        context.log(`[log] ${text}`);
        return context;
    }
    showStepForm(container, _context, onUpdated) {
        const cfg = this.config;
        container.innerHTML = `
      <div class="mb-3">
        <label class="form-label">Step name</label>
        <input type="text" class="form-control" data-faf="name" value="${escapeAttr(this.name)}" />
      </div>
      <div class="mb-3">
        <label class="form-label">Message</label>
        <textarea class="form-control" data-faf="message" rows="3" placeholder="Log message — supports {{ }}">${escapeText(String(cfg.message ?? ''))}</textarea>
        <div class="text-muted small">Supports {{ }} expressions. Written to console.log and the FAF execution log.</div>
      </div>
    `;
        const sync = () => {
            this.name = inputValue(container, 'name');
            this.config.message = textareaValue(container, 'message');
            onUpdated?.();
        };
        container.querySelectorAll('input, textarea').forEach((el) => {
            el.addEventListener('change', sync);
            el.addEventListener('blur', sync);
        });
    }
}
function inputValue(container, key) {
    const el = container.querySelector(`[data-faf="${key}"]`);
    return el?.value?.trim() ?? '';
}
function textareaValue(container, key) {
    const el = container.querySelector(`[data-faf="${key}"]`);
    return el?.value ?? '';
}
function escapeAttr(value) {
    if (value == null)
        return '';
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;');
}
function escapeText(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;');
}
registerStep('log', LogStep);
